import React from 'react'
import cn from 'classnames'
import { Card as BootstrapCard } from 'react-bootstrap'
import s from './Card.module.scss'

/* Header */
interface HeaderProps {
  children: React.ReactNode
  className?: string
}

const headerDefaultProps = {
  className: undefined,
}

const CardHeader = ({ children, className }: HeaderProps) => (
  <BootstrapCard.Header
    data-testid="card-header"
    className={cn(className, s.header)}
  >
    {children}
  </BootstrapCard.Header>
)

CardHeader.defaultProps = headerDefaultProps

/* Title */
interface TitleProps {
  children: React.ReactNode
  className?: string
}

const titleDefaultProps = {
  className: undefined,
}

const CardTitle = ({ children, className }: TitleProps) => (
  <BootstrapCard.Title
    data-testid="card-title"
    className={cn(className, s.title, {
      [s.old]: process?.env?.REACT_APP_RELEASE_TOGGLE_V2 !== 'true',
    })}
  >
    {children}
  </BootstrapCard.Title>
)

CardTitle.defaultProps = titleDefaultProps

/* Badge */
interface BadgeProps {
  children: React.ReactNode
  className?: string
}

const badgeDefaultProps = {
  className: undefined,
}

const CardBadge = ({ children, className }: BadgeProps) => (
  <div
    data-testid="card-badge"
    className={cn('card-badge', className, s.badge)}
  >
    {children}
  </div>
)

CardBadge.defaultProps = badgeDefaultProps

interface BodyProps {
  children: React.ReactNode
  className?: string
}

const bodyDefaultProps = {
  className: undefined,
}

const CardBody = ({ children, className }: BodyProps) => (
  <BootstrapCard.Body data-testid="card-body" className={cn(className, s.body)}>
    {children}
  </BootstrapCard.Body>
)

CardBody.defaultProps = bodyDefaultProps

/* Card */
interface Props {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  selected?: boolean
}

const defaultProps = {
  className: undefined,
  onClick: () => null,
  selected: false,
}

const Card = ({
  children,
  className,
  onClick,
  selected,
  ...props
}: Props): JSX.Element => (
  <BootstrapCard
    data-testid="card"
    className={cn(s.card, className, { [s.selected]: selected })}
    onClick={onClick}
    onKeyPress={onClick}
    {...props}
  >
    {children}
  </BootstrapCard>
)

Card.defaultProps = defaultProps
Card.Header = CardHeader
Card.Badge = CardBadge
Card.Title = CardTitle
Card.Body = CardBody

export default Card
